import {
  ACTIVITIES_GET,
  ACTIVITY_ADD,
  ACTIVITY_GET,
  ACTIVITY_EDIT,
  ACTIVITY_UPLOADFILE,
  ACTIVITY_DELETE,
  ACTIVITY_RESET_SEARCH,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    year: '',
    sem: '',
    jenjang: '',
    tingkat: '',
    kelas: '',
    pelajaran: '',
    published: 'all',
  },
  items: [],
  uploadStatus: 'finish',
};

const activitiesGet = (state, payload) => {
  const activities = payload.activities;
  
  return {
    total: activities.total,
    items: [...activities.items],
    search: { ...activities.search },
  };
};

const activityAdd = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) + 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.activity.id + ''),
      payload.activity,
    ],
  };
};

const activityGet = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.activity.id + ''),
      payload.activity,
    ],
  };
};

const activityEdit = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.activity.id + ''),
      payload.activity,
    ],
  };
};

const activityUploadFile = (state, payload) => {
  let status = payload.status;
  return {
    ...state,
    uploadStatus: status,
  };
};

const activityDelete = (state, payload) => {
  return {
    total: parseInt(state.total) - 1,
    items: [...state.items.filter((i) => i.id + '' !== payload.activity.id + '')],
    search: { ...state.search },
  };
};

const activityResetSearch = (state, payload) => {
  return {
    ...state,
    search: {
      year: '',
      sem: '',
      jenjang: '',
      tingkat: '',
      kelas: '',
      pelajaran: '',
      published: 'all',
    },
  };
};

export default createReducer(initialState, {
  [ACTIVITIES_GET]: activitiesGet,
  [ACTIVITY_ADD]: activityAdd,
  [ACTIVITY_GET]: activityGet,
  [ACTIVITY_EDIT]: activityEdit,
  [ACTIVITY_UPLOADFILE]: activityUploadFile,
  [ACTIVITY_DELETE]: activityDelete,
  [ACTIVITY_RESET_SEARCH]: activityResetSearch,
});
